import { GoogleLogin } from '@react-oauth/google';
import useWindowSize from '../hooks/useWindowSize';
import { getPersonalizedGoogleButtonWidth } from '../utils/googleSignInButton';
import './GoogleSignInButton.css';

export default function GoogleSignInButton({
  onSuccess,
  onError,
  text = 'signin',
  shape = 'pill',
  size = 'large',
}) {
  const { width } = useWindowSize();

  return (
    <div className="gis-personalized-button" data-testid="gis-personalized-button">
      <GoogleLogin
        onSuccess={onSuccess}
        onError={onError}
        text={text}
        shape={shape}
        size={size}
        width={getPersonalizedGoogleButtonWidth(width)}
      />
    </div>
  );
}
